export const THEADERS = ["Name", "Total Price", "Status"];
export const KEEP_ORDER_REASON_ERROR = "Keep order price reason is required when status is fulfilled or canceled";
export const VALIDATION_ERRORS = {
  keepReason: "Cancellation reason is required when status is Canceled",
  otherKeepReason: "Text is required when status is Canceled and Reason is Other",
};
